import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

import { ChatTimestamp } from './chat-timestamp.atom'

interface ChatMessageHeaderProps {
  senderName: string
  timestamp: string | Date
  isNote: boolean
  isRightAligned: boolean
}

/**
 * Header section showing sender name, optional note badge, and timestamp.
 */
export const ChatMessageHeader: FC<ChatMessageHeaderProps> = ({
  senderName,
  timestamp,
  isNote,
  isRightAligned,
}): ReactNode => (
  <div
    className={cn('flex items-center gap-2 px-1', isRightAligned ? 'flex-row-reverse' : 'flex-row')}
  >
    <span className="text-xs font-medium text-muted-foreground">{senderName}</span>
    {isNote && (
      <span className="text-xs font-medium text-yellow-600 dark:text-yellow-500">• Note</span>
    )}
    <ChatTimestamp timestamp={timestamp} />
  </div>
)

ChatMessageHeader.displayName = 'ChatMessageHeader'
